
import { Typography } from "@mui/material";
import ImageLink from './imageLink';

export default function Links() {
    return (

        <div className="tw-relative tw-min-h-[60vh] tw-flex tw-justify-center tw-items-center">
            <div
            style={{ backgroundImage: "url('/img/backGrounds/MapaMundo.jpg')" }}
            className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-bg-cover tw-bg-center tw-opacity-50 -tw-z-10" />

            <div className="tw-text-center tw-w-full tw-px-4">
                <Typography align="center" variant="h1" className="tw-text-[25px] tw-font-bold tw-mb-10">
                    LINKS
                </Typography>

                <div className="tw-w-full ">
                    <div className="tw-flex tw-gap-2.5 tw-overflow-x-auto tw-py-2 *:tw-scrollbar-hide tw-justify-center">
                        <ImageLink src="/img/linksUteis/oms.png" link="https://www.who.int/pt1" />
                        <ImageLink src="/img/linksUteis/thewordbank.png" link="https://www.worldbank.org/pt/country/angola" />
                        {/* <ImageLink src="/img/linksUteis/usaid.png" link="https://www.usaid.gov/" /> */}
                        <ImageLink src="/img/linksUteis/pnud.png" link="https://www.pnud.org/pt/angola" />
                        <ImageLink src="/img/linksUteis/ofa.svg" link="https://web.facebook.com/OrdemFarmaceuticosAngola/?_rdc=1&_rdr" />
                        <ImageLink src="/img/linksUteis/of.png" link="https://www.ordemfarmaceuticos.pt/pt/" />
                        <ImageLink src="/img/linksUteis/anvisa.png" link="https://www.gov.br/anvisa/pt-br" />
                        <ImageLink src="/img/linksUteis/infarmed.png" link="https://www.infarmed.pt/" />
                        <ImageLink src="/img/linksUteis/inis.png" link="https://inis.gov.ao/" />
                    </div>
                </div>
            </div>
        </div>
    )
}